var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mobile-app-area'),_c('b-button',{attrs:{"to":{name: 'CompetitionEdit'}}},[_c('b-icon',{attrs:{"icon":"pencil"}}),_vm._v(" Configuration de la compétition")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }